import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetAgency, useUpdateAgency } from "@/hooks/agencies";
import { Agency, CreateAgency } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(agencies)/agencies/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetAgency(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Agency }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateAgency({
    onSuccess: (agency) => {
      navigate({
        to: "/agencies",
        params: { id: agency.id.toString() },
      });
    },
  });

  const update = async (agency: CreateAgency) => {
    await mutateAsync({ id: model.id, ...agency });
  };
  return <Form model={model} onUpsert={update} />;
}
